// @ts-nocheck
export default () => {
    return new Date(new Date().setHours(0, 0, 0, 0));
};
